<template>
  <div id="FederationPlanPreview" class="full-page-with-header">
    <gjw-space-header class="page-header">
      <template #customContent>
        <span class="breadcrumb">
          <span class="name-click" @click.stop="toPage('FederationPlanList')">全部合模</span>
          <span> > 新建合模</span>
          <span class="grey-text">（*未保存）</span>
        </span>
        <el-button type="primary" size="mini" :disabled="!canSave" @click="toSavePlan">保存方案</el-button>
      </template>
    </gjw-space-header>
    <div class="page-content">
      <bimface
          :show-error="tokenError"
          :key="$route.name"
          :is-multiple="true"
          from="FEDERATED_PREVIEW"
          file-type="FEDERATED_PLAN"
          :multiple-view-token="federationSuccessViewTokens"
          height="100%"
          width="100%"
      />
    </div>
    <gjw-dialog
        :show-dialog="showSaveDialog"
        title="保存合模方案"
        :confirm-loading="saveLoading"
        @confirm="savePlan"
        @close="closeDialog"
    >
      <el-form ref="saveForm" :model="saveForm" :rules="rules" label-width="100px" @submit.native.prevent>
        <el-form-item label="方案名称：" prop="name">
          <el-input :maxlength="30" placeholder="请输入30个字内方案名称" v-model="saveForm.name" />
        </el-form-item>
      </el-form>
    </gjw-dialog>
  </div>
</template>

<script>
import GjwSpaceHeader from '@/components/business/GjwSpaceHeader.vue'
import { RegSymbol } from '@/core/RegExp'
import { mapGetters, mapMutations } from 'vuex'
import { createdFederationErrorCodeMap } from '@/views/file/errorCodeMap'
import Bimface from '@/components/common/Bimface.vue'

export default {
  name: 'FederationPlanPreview',
  components: { Bimface, GjwSpaceHeader },
  data() {
    const validName = (rule, value, callback) => {
      if (!value) return
      if (RegSymbol.test(value)) {
        callback(new Error(`不能包含特殊字符：\\ /:*<>|?'"#%`))
      } else {
        callback()
      }
    }
    return {
      spaceId: this.$route.params.spaceId,
      operationKey: this.$route.query.key,
      tokenError: false,
      // 预览的所有文件id
      fileIds: [],
      canSave: false,
      showSaveDialog: false,
      saveLoading: false,
      saveForm: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入30个字内方案名称', trigger: 'blur' },
          { validator: validName, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      federationPlanFileItems: 'fileModel/federationPlanFileItems',
      federationSuccessViewTokens: 'fileModel/federationSuccessViewTokens',
      federationFailFiles: 'fileModel/federationFailFiles',
    }),
  },
  created() {
    this.getFileViewTokens()
  },
  mounted() {
    if (this.$route.name === 'FederationPlanPreview') {
      document.title = '新建合模预览'
    }
  },
  methods: {
    ...mapMutations({
      setFederationPlanFileItems: 'fileModel/setFederationPlanFileItems',
    }),
    // 根据key获取文件的viewTokens
    async getFileViewTokens() {
      try {
        if (!this.operationKey || !this.spaceId) {
          this.$message.error('缺少关键参数，无法加载模型')
          return
        }
        const data = await this.$api.file.previewFederationPlan(this.spaceId, { operation_key: this.operationKey })
        this.setFederationPlanFileItems(data.fileItems)
        this.canSave = !this.hasFailFile()
      } catch (e) {
        this.tokenError = true
      }
    },
    // 是否有失效文件，有的话给出提示
    hasFailFile() {
      const length = this.federationFailFiles.length
      if (length) {
        const errFile = this.federationFailFiles[0]
        const errFileName = errFile.suffix ? `${errFile.fileName}.${errFile.suffix}` : errFile.fileName
        this.$confirm(`${errFileName}等${length}个文件发生了变动，暂不支持合模，请重新选择。`, {
          confirmButtonText: '确定',
          showCancelButton: false,
          showClose: false,
          type: 'error',
        }).then(() => {})
        return true
      } else {
        return false
      }
    },
    toPage(routeName) {
      this.$router.replace({ name: routeName })
    },
    closeDialog() {
      this.$refs.saveForm.resetFields()
      this.showSaveDialog = false
    },
    toSavePlan() {
      this.showSaveDialog = true
    },
    savePlan() {
      if (!this.$checkForm('saveForm')) { return }
      const params = {
        name: this.saveForm.name,
        fileIds: this.federationPlanFileItems.map((f) => f.fileId)
      }
      this.saveLoading = true
      this.$api.file.createFederationPlan(this.spaceId, params).then((data) => {
        this.setFederationPlanFileItems(data.fileItems)
        if (data.isSuccess) {
          this.closeDialog()
          this.$message.success('保存成功')
          this.$router.replace({
            name: 'FederationPlanView',
            params: { spaceId: this.spaceId },
            query: {
              id: data.federationPlanId,
              title: data.federationPlanName,
            }
          })
        } else {
          this.hasFailFile()
        }
      }).catch((err) => {
        this.$matchError(err.code, createdFederationErrorCodeMap, '保存失败')
      }).finally(() => {
        this.saveLoading = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
.breadcrumb {
  margin-right: 10px;
  font-size: 1rem;
  font-weight: normal;
  line-height: 22px;
  color: #495f70;
  .name-click{
    cursor: pointer;
    &:hover{
      color: @theme-color;
    }
  }
  .grey-text{
    color: rgba(73, 95, 112, 0.4);
  }
}
</style>
